module.exports = __webpack_public_path__ + "favicon_purple-dd918a246d55c3e085a0d6b688100184.png";